import React from "react";
import { ROUTES } from "ui/pages/routes";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
export interface PageConfig {
  title: string;
  routeMatch: string[];
  routeTo: string;
  icon: JSX.Element;
  showNewTabIcon: boolean;
  navType: "scroll" | "hidden";
  showIfAuthorised?: boolean;
  hideIfAuthorised?: boolean;
}

export interface IDictionary {
  [index: string]: PageConfig;
}

export const UnAuthenticated: IDictionary = {
  Resources: {
    title: "Resources",
    routeMatch: [ROUTES.learn],
    routeTo: ROUTES.learn,
    icon: <MenuIcon></MenuIcon>,
    showNewTabIcon: false,
    navType: "scroll",
  },
  OurApproach: {
    title: "Our Approach",
    routeMatch: [ROUTES.ourApproach],
    routeTo: ROUTES.ourApproach,
    showNewTabIcon: false,
    icon: <MenuIcon></MenuIcon>,
    navType: "scroll",
  },

  Contact: {
    title: "Get in Touch",
    routeMatch: [ROUTES.contact],
    routeTo: ROUTES.contact,
    showNewTabIcon: false,
    icon: <SearchIcon></SearchIcon>,
    navType: "scroll",
  },
};

export const Authenticated: IDictionary = {
  MyDashboard: {
    title: "My Wellbeing",
    routeMatch: [ROUTES.dashboard],
    routeTo: ROUTES.dashboard,
    icon: <MenuIcon></MenuIcon>,
    showNewTabIcon: false,
    navType: "scroll",
  },
  WellbeingTool: {
    title: "Wellbeing Plan",
    routeMatch: [
      ROUTES.assessmentResults,
      ROUTES.assessment,
      ROUTES.prioritise,
    ],
    routeTo: ROUTES.assessment,
    showNewTabIcon: false,
    icon: <MenuIcon></MenuIcon>,
    navType: "scroll",
  },
  Providers: {
    title: "Support",
    routeMatch: [ROUTES.search, ROUTES.book],
    routeTo: ROUTES.search,
    showNewTabIcon: true,
    icon: <SearchIcon></SearchIcon>,
    navType: "scroll",
  },
  Workshops: {
    title: "Workshops",
    routeMatch: [ROUTES.workshops],
    routeTo: ROUTES.workshops,
    showNewTabIcon: false,
    icon: <MenuIcon></MenuIcon>,
    navType: "scroll",
  },
  Resources: {
    title: "Resources",
    routeMatch: [ROUTES.learn],
    routeTo: ROUTES.learn,
    showNewTabIcon: false,
    icon: <MenuIcon></MenuIcon>,
    navType: "scroll",
  },
};
